import css_1m88xzkfqwv from './css/MediaGroupContainer.css';
import Div from './Div.js';
import MediaGroup from './MediaGroup.js';
import eventOptions from '../Functions/eventOptions.js';
import Spinner from './Spinner.js';

const css = css_1m88xzkfqwv;

export default class MediaGroupContainer extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.activeMediaGroup = new MediaGroup(this);
		this.spinner = new Spinner(this);

		this.activeMediaGroup.active(true);

		this.volume = 1;
		this.muted = true;

		const setVolumeTargets = [];
		setInterval
		(
			function()
			{
				let length = setVolumeTargets.length;
				while(length--)
				{
					if (!setVolumeTargets[length].parent)
					{
						setVolumeTargets.splice(length,1);
					}
				}
			},
			5000
		);

		const setVolume = target =>
		{
			let targets = target ? [target] : setVolumeTargets;

			let length = targets.length;
			while(length--)
			{
				if (!targets[length].parent)
				{
					targets.splice(length,1);
				}
				else
				{
					targets[length].postMessage
					(
						{
							type:'s2nEvent',
							s2nEvent:'setVolume',
							volume:this.volume,
							muted:this.muted,
						},
						'*'
					)
				}
			}
		};

		window.addEventListener
		(
			'message',
			event =>
			{
				if(event.data && event.data.type === 's2nEvent' && event.data.s2nEvent === 'getVolume')
				{
					setVolumeTargets.unshift(event.source);
					setVolume(event.source);
				}
			}
		);

		this.element.addEventListener
		(
			'contentVolumechange',
			event =>
			{
				let muted, volume;

				muted = this.activeMediaGroup.muted();
				volume = this.activeMediaGroup.volume();
				event.stopPropagation();

				if(this.volume !== volume || this.muted !== muted)
				{
					const detail = Object.assign({},event.detail);
					detail.previous =
					{
						muted: this.muted,
						volume: this.volume
					};

					detail.volume = volume;
					detail.muted = muted;

					this.volume = volume;
					this.muted = muted;

					this.dispatchEvent('mediaGroupContainerVolumechange',{detail:detail});
					setVolume();
				}
			},
			eventOptions({capture:true})
		)
	}

	get cssText()
	{
		return css;
	}
}
